import React from "react";

interface CountryFlagProps {
  alpha2?: string;
  style?: React.CSSProperties;
  className?: string;
  title?: string;
}

const CountryFlag: React.FC<CountryFlagProps> = ({
  alpha2,
  style,
  className,
  title,
}) => {
  if (!alpha2) return null;
  const code = alpha2.toLowerCase();
  return (
    <span
      className={`fi fi-${code}${className ? ` ${className}` : ""}`}
      title={title}
      style={{
        display: "inline-block",
        width: "1.2em",
        height: "0.9em",
        verticalAlign: "middle",
        borderRadius: 2,
        ...style,
      }}
    />
  );
};

export default CountryFlag;
